module.exports = __webpack_public_path__ + "img/joomla.ec814c2.svg";